<style scoped>
.h-btn {
    min-width: 200px;
}

.no-href-dec {
    text-decoration: none;
    cursor: pointer;
}
.branch-select{
    min-width:200px
}
</style>
<template>
    <!-- Content -->
    <div class="content-wrapper">
        <div class="row mb-3">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-12 col-xl-8 mb-4 mb-xl-0">
                        <h3 class="font-weight-bold">Incoming Parcels</h3>
                    </div>
                    <div class="col-12 col-xl-4">

                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="row">
                     <div class="col-sm-4 col-md-5 col-6 stretch-card col-grid">

                     </div>
                      <div class="col-sm-12 col-md-3 col-12 stretch-card col-grid">
<div class="d-flex w-100">
                                            <input type="text" v-model="this.filter_branch"
                                                style="width: 100px !important;" class="form-control"
                                                placeholder="Filter">
                                            <select v-model="branch_from" class="form-select form-control">
                                                <option v-for="branch in branches" :key="branch.id" :value="branch.id">
                                                    {{ branch.name }}
                                                </option>
                                            </select>
                                        </div>
                      </div>
                       <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
   <button id="filter_btn" @click="filterByBranch" class="btn btn-primary simple-btn">Filter</button>
                       </div>
                        <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                        <button v-if="!contact_form" @click="showSMSForm" class="btn btn-success text-white simple-btn">SendSMS</button>
                        <button v-if="contact_form" @click="showSMSForm" class="btn btn-danger text-white simple-btn">CloseSMS</button>
                        </div>
                        

                                       
                </div>

                <div v-if="contact_form">
                    <div class="card mt-3">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-7 col-sm-12">
                                    <div class="form-group">
                                        <label for="">Phone numbers (comma separated)</label>
                                        <textarea class="form-control" rows="5" v-model="this.phone_list"></textarea>
                                    </div>
                                </div>
                                <div class="col-md-5 col-sm-12">
                                    <div class="form-group">
                                        <label for="">Message</label>
                                        <textarea class="form-control" v-model="this.message"></textarea>
                                    </div>
                                   
                                    <div class="d-flex justify-content-between">
                                        <button class="btn btn-primary" @click="sendSms()">Send SMS</button>
                                        <button class="btn btn-danger text-white" @click="clearPhoneList">Clear Chat</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                 <div v-if="loading" class="mt-1">
                                                <div class="text-center">
                                                    <div class="spinner-grow text-success" role="status"></div>
                                                    <div class="spinner-grow text-danger" role="status"></div>
                                                    <div class="spinner-grow text-warning" role="status"></div>
                                                </div>
                                            </div>

                <div class="table-responsive">
                    
                    <table class="table table-striped mt-3">
                        <thead>
                            <tr class="thead-style">
                                <th>No</th>
                                <th> Package Label</th>
                                <th>Price</th>
                                <th>Package Name</th>
                                <th> Receiver name </th>
                                <th> Receiver phone </th>
                                <th> Sender branch </th>
                                <th> Sender staff </th>
                                <th> Date issue </th>
                                <th> Action </th>
                            </tr>
                        </thead>
                        <tbody id="incoming-list">

                            <tr v-for="(parcel, index) in paginatedParcels" :key="parcel.id" :id="'parcel_'+parcel.id">
                                <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>
                               
                                <td v-if="parcel.package_size == 'S'"><span class="text-success text-small">[S] </span><span
                                        class="text-capitalize">{{ parcel.name }}</span></td>
                                <td v-else><span class="text-danger">[R] </span><span
                                        class="text-capitalize">{{ parcel.name }}</span>
                                </td>

                                <td><PriceFormat :Price="parcel.price"/></td>
                                <td><label class="badge badge-dark">{{ parcel.package_tag }}</label></td>
                                <td class="text-capitalize"> {{ parcel.receiver_name }} </td>
                                <td> <a class="text-success no-href-dec add_phone"
                                        @click="addPhoneList(parcel.receiver_phone)">{{ parcel.receiver_phone }} <i
                                            class="mdi mdi-message-processing"></i></a></td>
                                <td><label class="badge badge-primary">{{ parcel.bname }}</label></td>
                                <td> <label class="badge badge-success">{{ parcel.fulname }}</label></td>
                                <td><DateFormat :Date_="parcel.created_at"/></td>
                                <td>
                                    <button type="button" @click="getReceiveParcel(parcel)"
                                        class="btn receive_btn btn-primary btn-icon">
                                        <i class="mdi mdi-gift"></i>
                                    </button>
                                </td>
                            </tr>
                          
                        </tbody>
                    </table>
                </div>
                           <div class="pagination-wrapper">

  <button 
    @click="currentPage--"
    :disabled="currentPage === 1">
    Prev
  </button>

  <button
    v-for="page in totalPages"
    :key="page"
    @click="currentPage = page"
    :class="{ active: currentPage === page }">
    {{ page }}
  </button>

  <button
    @click="currentPage++"
    :disabled="currentPage === totalPages">
    Next
  </button>

</div>
            </div>
        </div>
    </div>

    <!--receiver -->
    <div class="modal fade mobile-full-width" id="receiveModal" tabindex="-1" data-bs-backdrop="static"
        data-bs-keyboard="false" role="dialog" aria-labelledby="receiveModal" aria-hidden="true">
        <div class="modal-dialog modal-md" role="document">

            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="font-weight-bold">Receive Package</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    </button>
                </div>
                <div class="container mt-3 mb-3">
                    <div class="row">
                       
                        <div class="col-sm-12">
                            <h4 class="text-center mt-3">{{ parcel.name }}</h4>
                            <h5 id="">Sender : {{ parcel.sender_name }} - {{ parcel.sender_phone }}</h5>
                            <h5 id="">Receiver : {{ parcel.receiver_name }} - {{ parcel.receiver_phone }}</h5>
                        </div>

                        <div class="col-sm-12 col-md-12">
                            <div class="form-group">
                                <label class="form-label">Comment (option)</label>
                                <textarea v-model="this.receive_description" maxlength="400"
                                    class="form-control text-area-style" rows="2" style="width: 100% !important;"
                                    placeholder="give reason to remove the package">wel received</textarea>
                            </div>
                          
                            <div v-if="loading" class="mt-1">
                                                <div class="text-center">
                                                    <div class="spinner-grow text-success" role="status"></div>
                                                    <div class="spinner-grow text-danger" role="status"></div>
                                                    <div class="spinner-grow text-warning" role="status"></div>
                                                </div>
                                            </div>

                            <button type="button" @click="receivePackage" class="btn btn-primary w-100 mt-3">Receive
                                Package</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import axios from "axios";

import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";


export default {
    components: {
        PriceFormat,
        PhoneFormat,
        DateFormat,

    },
    data() {
        return {
            loading: false,
            contact_form:false,
            errors: "",
            phone_list:"",
            message:"",
            receive_description:"wel received",
            tags: [],
            branches: [],
            og_branches: [],
            branch_from:0,
            filter_branch: "",
            parcels:[],
            og_parcels:[],
            parcel: {},
            currentPage: 1,
            perPage: 30,
            user: this.$attrs.user
        };
    },
    methods: {

        async filterByBranch(){

             this.loading = true

       
          var branch_from = this.branch_from

          var response = await axios
              .post(this.$store.state.api_url + "/filter-incoming-parcels", {branch_from})
              .catch((errors) => {
                    this.loading = false
                  var message = "Network or Server Errors";
                  this.$toast.error(message, { duration: 5000, dismissible: true });
              });

          //console.log(response.data)
          if (response.data.success) {

               this.loading = false

                this.parcels = response.data.parcels;
                this.og_parcels = response.data.parcels
             
          } else {
                this.loading = false
              var message = response.data.message;
              this.$toast.error(message, { duration: 5000, dismissible: true });
          }

        },

        async receivePackage(){

          this.loading = true

          var closed_description = this.receive_description
          var barcode_id = this.parcel.barcode_id
          var pid = this.parcel.id

          var response = await axios
              .post(this.$store.state.api_url + "/receive-package", {closed_description, barcode_id, pid,})
              .catch((errors) => {
                    this.loading = false
                  var message = "Network or Server Errors";
                  this.$toast.error(message, { duration: 5000, dismissible: true });
              });

          //console.log(response.data)
          if (response.data.success) {

               this.loading = false
            
               const modal = bootstrap.Modal.getOrCreateInstance(
                document.getElementById("receiveModal")
            );

            modal.hide();

            document.getElementById('parcel_' + pid).remove()
             
          } else {
                this.loading = false
              var message = response.data.message;
              this.$toast.error(message, { duration: 5000, dismissible: true });
          }

        },

        getReceiveParcel(parcel) {

            this.parcel = parcel

            const modal = bootstrap.Modal.getOrCreateInstance(
                document.getElementById("receiveModal")
            );

            modal.show();
        },
        showSMSForm(){
            this.contact_form = !this.contact_form
        },

        async getOtherBranch() {

            var response = await axios
                .get(this.$store.state.api_url + "/branch/other-branches")
                .catch((errors) => {
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                this.branches = [ { id: 0, name: "All Branches" },...response.data.branches];
                this.og_branches = [ { id: 0, name: "All Branches" },...response.data.branches];

            } else {
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

        async getParcels() {


            this.loading = true

            var response = await axios
                .get(this.$store.state.api_url + "/web/incoming-parcels")
                .catch((errors) => {
                    this.loading = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {
this.loading = false
                this.parcels = response.data.parcels;
                this.og_parcels = response.data.parcels

               /// console.log(this.parcels)

            } else {
                this.loading = false
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },
         nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++
    }
  },

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--
    }
  },

 addPhoneList(phone) {

    this.contact_form = true
        // Convert string to array and remove empty values
        let phones = this.phone_list
            ? this.phone_list.split(",").map(p => p.trim()).filter(Boolean)
            : [];

        // Check if phone already exists
        const index = phones.indexOf(phone);

        if (index !== -1) {
            if (confirm(`${phone} already exists.\n\nDo you want to remove it?`)) {
                phones.splice(index, 1);
            } else {
                return;
            }
        } else {
            phones.push(phone);
        }

        // Convert back to comma-separated string
        this.phone_list = phones.join(",");
    },
    clearPhoneList(){
        this.phone_list = ""
    },
  async sendSms (){

    this.loading = true

          var phone_list = this.phone_list
          var message = this.message

          var response = await axios
              .post(this.$store.state.api_url + "/send-multi-sms", {phone_list, message})
              .catch((errors) => {
                    this.loading = false
                  var message_ = "Network or Server Errors";
                  this.$toast.error(message_, { duration: 5000, dismissible: true });
              });

          //console.log(response.data)
          if (response.data.success) {
               this.loading = false
             
              var message_ = response.data.message;
              this.$toast.success(message_, { duration: 5000, dismissible: true });

              this.phone_list = ""
              this.message = ""

          } else {
            
                this.loading = false
              var message_ = response.data.message;
              this.$toast.error(message_, { duration: 5000, dismissible: true });
          }
    }

    },
      computed: {

  paginatedParcels() {
    const start = (this.currentPage - 1) * this.perPage
    const end = start + this.perPage

    return this.parcels.slice(start, end)
  },

  totalPages() {
    return Math.ceil(this.parcels.length / this.perPage)
  },
  

},
    watch: {

        filter_branch(value) {

            let term = value.toLowerCase().trim()

            if (!term) {
                this.branches = this.og_branches
                return
            }

            this.branches = this.og_branches.filter(branch => {

                return (
                    (branch.name && branch.name.toLowerCase().includes(term))
                )

            })

        }
    },
    created() {
        this.$store.state.page_name = "Dashbord"
        this.getOtherBranch()
        this.getParcels()
    },
    mounted() {
        //$('#dashbord').attr('class', 'nav-item active');
    }
};
</script>
